import { PageableResponse } from "./talkServices";
import request from "../libs/request";
import { LifeSpaceReviewId, SpaceId } from "../types/talk";

export type SpaceIdRequest = {
  spaceId: SpaceId;
};

export type GetSpaceReviewRequest = SpaceIdRequest & {
  page?: number;
  pageSize?: number;
};

export type ReviewItem = {
  content: string;
  createdAt: string;
  createdBy: number;
  createdByName: string;
  createdByNickName: string;
  createdByThumbnail: string;
  lifeSpaceReviewId: LifeSpaceReviewId;
  rating?: number;
  parentId?: number;
  spaceId?: SpaceId;
  reply?: ReviewItem[];
};

export const getSpaceReview = (params: GetSpaceReviewRequest) =>
  request.get<PageableResponse<ReviewItem>>(`space/review/${params.spaceId}`);

export type SpaceReviewSummaryResponse = {
  spaceId: SpaceId;
  rating: number;
  countReview: number;
  spaceName: string;
  isReviewedStore: boolean;
};

export const getSpaceReviewSummary = (params: SpaceIdRequest) =>
  request.get<SpaceReviewSummaryResponse>(
    `space/review/summary/${params.spaceId}`
  );

export type ReviewRequest = {
  content: string;
  rating: number;
};

// 리뷰 등록 시 해당 식당 그룹에 속한 ROLE_CAFETERIA(공지) 샌디매니저들에게 push 발송
export const postReview = (spaceId: SpaceId, params: ReviewRequest) =>
  request.post(`space/review/${spaceId}`, params);

export const updateReview = (
  lifeSpaceReviewId: LifeSpaceReviewId,
  params: ReviewRequest
) => request.patch(`space/review/${lifeSpaceReviewId}`, params);

export type ReviewReplyRequest = {
  content: string;
};

export type PostReviewReplyRequest = ReviewReplyRequest & {
  spaceId: SpaceId;
};

// 리뷰 답글 등록 시 리뷰 등록자에게 push 발송
export const postReviewReply = (
  lifeSpaceReviewId: LifeSpaceReviewId,
  params: PostReviewReplyRequest
) => request.post(`space/review/reply/${lifeSpaceReviewId}`, params);

export const updateReviewReply = (
  lifeSpaceReviewId: LifeSpaceReviewId,
  params: ReviewReplyRequest
) => request.patch(`space/review/reply/${lifeSpaceReviewId}`, params);

export const deleteReview = (lifeSpaceReviewId: LifeSpaceReviewId) =>
  request.delete(`space/review/${lifeSpaceReviewId}`);
